export type Dimension = {
  x: number;
  y: number;
};

export const FINAL_SCALE = 1;
export const BUTTONS_TRIGGER = 1;
